export default {
  methods: {
    putSearchInputInQueryParams () {
      let object = {}
      for (const prop in this.searchInput) {
        if (
          this.searchInput[prop] &&
          (!Array.isArray(this.searchInput[prop]) || this.searchInput[prop][0] !== '')
        ) {
          object[prop] = this.searchInput[prop]
        } else if (this.queryParams[prop]) {
          this.$delete(this.queryParams, prop)
        }
      }

      this.queryParams = { ...this.queryParams, ...object }
    },

    putSearchInputWithOperatorInQueryParams () {
      let object = {}
      for (const prop in this.searchInputWithOperator) {
        if (
          this.searchInputWithOperator[prop] &&
          this.searchInputWithOperator[prop + 'Operator']
        ) {
          object[prop] = this.searchInputWithOperator[prop]
          object[prop + 'Operator'] = this.searchInputWithOperator[prop + 'Operator']
        } else if (this.queryParams[prop]) {
          this.$delete(this.queryParams, prop)
        }
      }

      this.queryParams = { ...this.queryParams, ...object }
    },

    putSearchInputWithClauseTypeInQueryParams () {
      let object = {}
      for (const prop in this.searchInputWithClauseType) {
        object[prop] = []
        for (const index in this.searchInputWithClauseType[prop]) {
          for (const value in this.searchInputWithClauseType[prop][index]) {
            let obj = this.searchInputWithClauseType[prop][index][value]
            if (obj['value'] !== '' && obj['clauseType'] !== '') {
              object[prop].push(`${obj['value']}__${obj['clauseType']}--${index}`)
            }
          }
        }
      }

      this.queryParams = { ...this.queryParams, ...object }
    },

    putQueryParamsInSearchInput () {
      for (const prop in this.searchInput) {
        if (this.queryParams.hasOwnProperty(prop) && this.queryParams[prop]) {
          this.searchInput[prop] = this.queryParams[prop]
        } else {
          this.searchInput[prop] = Array.isArray(this.searchInput[prop]) ? [''] : ''
        }
      }
    },

    putQueryParamsInSearchInputWithOperator () {
      for (const prop in this.searchInputWithOperator) {
        if (this.queryParams.hasOwnProperty(prop) && this.queryParams[prop]) {
          this.searchInputWithOperator[prop] = this.queryParams[prop]
        } else {
          this.searchInputWithOperator[prop] = ''
        }
      }
    },

    putQueryParamsInSearchInputWithClauseType () {
      for (const prop in this.searchInputWithClauseType) {
        if (this.queryParams.hasOwnProperty(prop)) {
          for (const index in this.searchInputWithClauseType[prop]) {
            this.$set(this.searchInputWithClauseType[prop], index, [])
          }
          if (Array.isArray(this.queryParams[prop])) {
            for (const item in this.queryParams[prop]) {
              const s = this.queryParams[prop][item].split('--')
              const index = s[1]
              const values = s[0].split('__')
              this.searchInputWithClauseType[prop][index].push({ clauseType: values[1], value: values[0] })
            }
            for (const index in this.searchInputWithClauseType[prop]) {
              if (!this.searchInputWithClauseType[prop][index].length) {
                this.searchInputWithClauseType[prop][index].push({ clauseType: '', value: '' })
              }
            }
          }
        } else {
          if (Array.isArray(this.searchInputWithClauseType[prop])) {
            for (const index in this.searchInputWithClauseType[prop]) {
              if (!this.searchInputWithClauseType[prop][index].length) {
                this.$set(this.searchInputWithClauseType[prop], index, [{ clauseType: '', value: '' }])
              }
            }
          }
        }
      }
    },

    updateUrl (params) {
      for (let item in this.queryParams) {
        // In the case of multivalued params (arrays), we remove falsy values
        // to avoid errors on the API
        if (Array.isArray(this.queryParams[item])) {
          this.queryParams[item] = this.queryParams[item].filter(Boolean)
        }
      }

      this.$router.push({
        name: this.$route.name,
        params: params,
        query: this.queryParams
      })
    },

    handleMultiValuatedQueryParam (listOfName) {
      // We retrieved a multi-valuated parameter from the url but if there's
      // only one occurrence, it won't be handled as an array thus we won't be
      // able to query the API with it as parameter as it expects an array
      for (const index in listOfName) {
        if (
          this.queryParams[listOfName[index]] &&
          !Array.isArray(this.queryParams[listOfName[index]])
        ) {
          this.queryParams[listOfName[index]] = Array(this.queryParams[listOfName[index]])
        }
      }
    },

    deepCopy (object) {
      return JSON.parse(JSON.stringify(object))
    },

    search () {
      if (this.$refs.form.checkValidity()) {
        this.putSearchInputInQueryParams()
        this.putSearchInputWithOperatorInQueryParams()
        this.putSearchInputWithClauseTypeInQueryParams()
        this.updateUrl({ results: 'results' })
      }
    },

    clearSearch () {
      this.queryParams.page = undefined
      for (const prop in this.searchInput) {
        this.searchInput[prop] = Array.isArray(this.searchInput[prop]) ? [''] : ''
      }
      this.putSearchInputInQueryParams()
      for (const prop in this.searchInputWithOperator) {
        this.searchInputWithOperator[prop] = ''
      }
      this.putSearchInputWithOperatorInQueryParams()
      for (const prop in this.searchInputWithClauseType) {
        if (Array.isArray(this.searchInputWithClauseType[prop])) {
          for (const index in this.searchInputWithClauseType[prop]) {
            this.$set(this.searchInputWithClauseType[prop], index, [{ clauseType: '', value: '' }])
          }
        } else {
          for (const item in this.searchInputWithClauseType[prop]) {
            this.searchInputWithClauseType[prop][item] = ''
          }
        }
      }
      this.putSearchInputWithClauseTypeInQueryParams()
      this.updateUrl()
    },

    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
